// @ts-nocheck
import { immerable } from "immer";
import { LenssourceModelLensSourceType as LensSourceType } from "../../../gql-generated/types";
import { type SourceModel } from "../models";

export class SourcesByType {
    public [immerable] = true;
    type: LensSourceType;
    sources: SourceModel[];
}
